import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const etudiantRessentiEvaluationPedagogique = {
  state: {
    ressenti: null,
  },
  mutations: {
    setRessenti(state, ressenti){
      state.ressenti = ressenti;
    },
  },
  actions: {
    async fetchRessentisEtudiantById(context, ressenti){
      try{
        const response = await ApiService.getRequest(ressenti);
        context.commit('setRessenti', response.data);

      }catch (e) {
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    }
  },
  getters: {
    getRessentiEtudiant(state){
      return state.ressenti;
    }
  }
}
